import { render, staticRenderFns } from "./VerifyBusinessAddressPhoneStepper.vue?vue&type=template&id=2b193fc9&"
import script from "./VerifyBusinessAddressPhoneStepper.vue?vue&type=script&lang=js&"
export * from "./VerifyBusinessAddressPhoneStepper.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports